import React, { useEffect }from 'react';
import { useHistory } from 'react-router'
import styles from './css/Error.module.css';
import { Layout, Button } from 'antd';
import * as CONSTANTS from '../../constants/constants';
import { Header, Footer } from "./CorePageContents";

const { Content } = Layout;

export const NotFoundError = () => {

  let history = useHistory();

  useEffect(() => {
    history.replace(CONSTANTS.PATH_NOT_FOUND_ERROR);
  }, []);

  const onClickPrevBack = () => {
    history.push(CONSTANTS.PATH_TOP);
    return <></>;
  }

  return (
    <Layout>
      <Header />
      <Content>
        <div className={styles.mainMessage}>ページが見つかりません</div>
        <br />
        <br />
        <br />
        <div className={styles.subMessage}>
          指定されたページが見つかりません。<br />
          以下のボタンからTOPページへお戻りください。
        </div>
        <br />
        <br />
        <Button
          className={styles.sysButton}
          onClick={onClickPrevBack}
        >
          TOPページへ戻る
        </Button>
      </Content>
      <Footer />
    </Layout>
  )
}
